import TransactionsTableItem from './TransactionsTableItem'

export default TransactionsTableItem
